import { SubSink } from 'subsink';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { AuthenticationService } from '../services/authentication.service';
var LoginAdminComponent = (function () {
    function LoginAdminComponent(authService, activatedRoute, router) {
        this.authService = authService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.errorMessage = null;
        this.subs = new SubSink();
    }
    LoginAdminComponent.prototype.ngOnInit = function () {
        var _this = this;
        localStorage.clear();
        this.subs.add(this.activatedRoute.params.subscribe(function (params) {
            _this.errorMessage = params.msg || null;
        }));
    };
    LoginAdminComponent.prototype.login = function () {
        var _this = this;
        this.errorMessage = null;
        if (_.isNil(this.username) || _.isNil(this.password)) {
            this.errorMessage = 'โปรดกรอกข้อมูลให้ครบถ้วน';
            return;
        }
        this.subs.add(this.authService.login(this.username, this.password).subscribe(function (user) {
            var token = _.get(user, 'token');
            localStorage.clear();
            localStorage.setItem('currentUser', token);
            _this.authService.updateUserInfo(user);
            if (token != null) {
                _this.router.navigate(['']);
            }
        }, function (error) {
            if (error != null && error.status === 400) {
                _this.errorMessage = 'ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง';
            }
            else {
                _this.errorMessage = 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง';
            }
        }));
    };
    LoginAdminComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return LoginAdminComponent;
}());
export { LoginAdminComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/login-admin/login-admin.component.ts.pre-build-optimizer.js